<template>
    <section>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>{{'amount' | langFilter}}</th>
            <th>{{'date' | langFilter}}</th>
            <th>{{'categories' | langFilter}}</th>
            <th>{{'type' | langFilter}}</th>
            <th>{{'open' | langFilter}}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(rec, idx) in records" :key="rec.id">
            <td>{{itemCounter+idx}}</td>
            <td>{{rec.amount | currencyFilter}}</td>
            <td>{{rec.date | date('datetime')}}</td>
            <td>{{rec.name}}</td>
            <td>
              <span class="white-text badge" :class="rec.color">{{rec.text}}</span>
            </td>
            <td>
              <button class="btn-small btn" @click="$router.push('/detail/' + rec.id)" v-tooltip="'more'" :key="$store.getters.info.lang">
                <i class="material-icons">open_in_new</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
</template>

<script>
export default {
    props: ['records', 'itemCounter'],
}
</script>
